import(/* webpackMode: "eager" */ "/www/wwwroot/okwintv.top/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/okwintv.top/src/app/lich-thi-dau-bong-da/LichThiDau.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/okwintv.top/src/components/ClientHomeContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/www/wwwroot/okwintv.top/src/components/DynamicPageHeader.tsx");
